import "./MainSection.css";
import MainSectionTour from "../MainSectionTours/MainSectionTours"
import MainSectionDescription from "../MainSectionDescription/MainSectionDescription";
import MainSectionLast from "../MainSectionLast/MainSectionLast";
import MainSectionAbouts from "../MainSectionAbouts/MainSectionAbouts";
import MainSectionLogo from "../MainSectionLogo/MainSectionLogo";
import MainSectionPhoto from "../MainSectionPhoto/MainSectionPhoto";
import MainSectionFeedback from "../MainSectionFeedback/MainSectionFeedback";
import MainSectionBooking from "../MainSectionBooking/MainSectionBooking";
import MainSectionInsta from "../MainSectionInsta/MainSectionInsta";
import MainSectionContact from "../MainSectionContact/MainSectionContact";


function MainSection () {

    return (
        <>
            <MainSectionDescription/>
            <MainSectionAbouts/>
            <MainSectionLogo/>
            <MainSectionPhoto/>
            <MainSectionTour/>
            <MainSectionBooking/>
            <MainSectionInsta/>
            <MainSectionFeedback/>
            <MainSectionContact/>
            <MainSectionLast/>
            
        </>
    );
}
export default MainSection;